/** @module Camunda/FilmstripTaskCardRenderer */
define([
	"dojo/_base/declare",
	"underscore",
	"./TaskCardRenderer"
], function(declare, _, TaskCardRenderer) {

	return declare(TaskCardRenderer, {
		/**
		 * @override
		 * Specify anchor href and text for attribute card
		 */
		onAttributeCardParams: function(ctx, params) {
			const {queryResult} = ctx;

			params.onClick = function() {
				_.defer(function() {
					ctx.view.set("filmstripSelection", queryResult.id);
				});
			};

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Do not show tooltip for selected task
		 */
		toTooltip: function(ctx, h, tooltip) {
			if (ctx.view.getFilmstripSelectedUrl() != ctx.getNodeURL()) {
				this.inherited(arguments);
			}
		}
	});
});
